import React from "react";
import { Link } from "react-router-dom";
import ScrollToTop from "../components/ScrollToTop";

const Cookies: React.FC = () => {
  return (
    <div className="d-flex flex-column mb-5" style={{height:'100%', backgroundColor: '#f8f6f0'}}>
      <ScrollToTop />
      
      {/* Breadcrumb */}
      <div className="py-3">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-0 font_two">
              <li className="breadcrumb-item">
                <Link to="/" className="text-decoration-none active text-dark ">
                  Home
                </Link>
              </li>
              <li
                className="breadcrumb-item fw_700 font-medium"
                aria-current="page"
              >
                Cookie Policy
              </li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Main Content */}
      <div className="container flex-grow-1 py-4">
        <div className="container flex-grow-1 d-flex flex-column flex-md-row py-4">
        {/* Left Content */}
          <div className="col-lg-4 col-md-5 mb-4 mb-md-0">
          <h1 className="mb-3" style={{fontSize: '2.5rem', fontWeight: '500', color: '#2c3e50', fontFamily: 'Lora'}}>
            Cookie Policy
          </h1>
          <p className="text-muted mb-0 font-satoshi" style={{fontSize: '1.1rem', lineHeight: '1.6', fontFamily: 'Satoshi, sans-serif', textAlign:'justify'}}>
              Our website uses cookies to enhance your browsing experience, personalize content, and analyze site traffic.
          </p>
          <p className="text-muted mt-2 font-satoshi" style={{fontSize: '0.9rem', fontWeight: '500', fontFamily: 'Satoshi, sans-serif'}}>
            Last Updated: January 6, 2026
          </p>
        </div>

          <div>
            <hr className="mt-0" />
        </div>

      {/* Vertical Divider */}
      <div className="d-none d-lg-block" style={{
          padding: '0.5px',
          backgroundColor: '#112C3B4D',
          margin: '0 2rem',
          alignSelf: 'stretch'
        }}>
        </div>

          {/* Right Content */}
          <div className="col-lg-8 col-md-7">
            <div className="cookie-content" style={{lineHeight: '1.7', fontFamily: 'Satoshi, sans-serif', textAlign:'justify'}}>
            {/* Introduction */}
            <div className="mb-4">
              <h3 style={{fontSize: '1.2rem', fontWeight: '600', color: '#2c3e50'}}>
                Introduction
              </h3>
              <p style={{fontSize: '1rem', color: '#555', marginBottom: '0'}}>
                This Cookie Policy explains how Digi Cartt ("we", "us", or "our") uses cookies and similar technologies when you visit our website at https://digicartt.com/ (the "Site"). This policy explains what these technologies are, why we use them, and your rights to control our use of them.
              </p>
          </div>

            {/* What Are Cookies? */}
            <div className="mb-4">
              <h3 style={{fontSize: '1.2rem', fontWeight: '600', color: '#2c3e50'}}>
                What Are Cookies?
              </h3>
              <p style={{fontSize: '1rem', color: '#555', marginBottom: '0.5rem'}}>
                Cookies are small text files that are placed on your device (computer, smartphone, or tablet) when you visit a website. They are widely used to make websites work more efficiently and provide information to website owners.
              </p>
              <p style={{fontSize: '1rem', color: '#555', marginBottom: '0'}}>
                Cookies can be "persistent" or "session" cookies. Persistent cookies remain on your device after you close your browser and allow a website to recognize your device on subsequent visits. Session cookies are deleted when you close your browser.
              </p>
            </div>

            {/* How We Use Cookies */}
            <div className="mb-4">
              <h3 style={{fontSize: '1.2rem', fontWeight: '600', color: '#2c3e50'}}>
                How We Use Cookies
              </h3>
              <p style={{fontSize: '1rem', color: '#555', marginBottom: '0.5rem'}}>
                We use cookies for the following purposes:
              </p>
              
              <p style={{fontSize: '1rem', color: '#555', marginBottom: '0.5rem', fontWeight: '500'}}>
                <strong>1. Essential Cookies</strong>
              </p>
              <p style={{fontSize: '1rem', color: '#555', marginBottom: '0.5rem'}}>
                These cookies are necessary for the website to function properly. They enable core functionality such as:
              </p>
              <ul style={{fontSize: '1rem', color: '#555', paddingLeft: '1.2rem', marginBottom: '0.5rem', listStyleType: 'disc'}}>
                <li>Maintaining your session while browsing</li>
                <li>Remembering items in your shopping cart</li>
                <li>Security and authentication</li>
                <li>Remembering your privacy preferences</li>
              </ul>
              <p style={{fontSize: '1rem', color: '#555', marginBottom: '1rem'}}>
                <strong>Legal Basis:</strong> These cookies are strictly necessary for the operation of our Site. Without these cookies, services you have requested cannot be provided.
              </p>

              <p style={{fontSize: '1rem', color: '#555', marginBottom: '0.5rem', fontWeight: '500'}}>
                <strong>2. Performance and Analytics Cookies</strong>
              </p>
              <p style={{fontSize: '1rem', color: '#555', marginBottom: '0.5rem'}}>
                These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously. They help us:
              </p>
              <ul style={{fontSize: '1rem', color: '#555', paddingLeft: '1.2rem', marginBottom: '0.5rem', listStyleType: 'disc'}}>
                <li>Analyze website traffic and usage patterns</li>
                <li>Identify and fix technical issues</li>
                <li>Improve website performance and user experience</li>
                <li>Understand which pages are most popular</li>
              </ul>
              <p style={{fontSize: '1rem', color: '#555', marginBottom: '1rem'}}>
                We may use services such as Google Analytics for this purpose.
              </p>

              <p style={{fontSize: '1rem', color: '#555', marginBottom: '0.5rem', fontWeight: '500'}}>
                <strong>3. Functionality Cookies</strong>
              </p>
              <p style={{fontSize: '1rem', color: '#555', marginBottom: '0.5rem'}}>
                These cookies allow our website to remember choices you make (such as language preferences or region) and provide enhanced, personalized features. They may include:
              </p>
              <ul style={{fontSize: '1rem', color: '#555', paddingLeft: '1.2rem', marginBottom: '1rem', listStyleType: 'disc'}}>
                <li>Language preferences</li>
                <li>Display preferences</li>
                <li>Previously viewed products or content</li>
                <li>User interface customization</li>
              </ul>

              <p style={{fontSize: '1rem', color: '#555', marginBottom: '0.5rem', fontWeight: '500'}}>
                <strong>4. Marketing and Advertising Cookies</strong>
              </p>
              <p style={{fontSize: '1rem', color: '#555', marginBottom: '0.5rem'}}>
                These cookies may be used to deliver advertisements that are relevant to you and your interests. They may also be used to:
              </p>
              <ul style={{fontSize: '1rem', color: '#555', paddingLeft: '1.2rem', marginBottom: '0'}}>
                <li>Limit the number of times you see an advertisement</li>
                <li>Measure the effectiveness of advertising campaigns</li>
                <li>Track whether you've already seen a particular advertisement</li>
                <li>Build a profile of your interests for targeted advertising</li>
              </ul>
              <p style={{fontSize: '1rem', color: '#555', marginTop: '0.5rem', marginBottom: '0'}}>
                These cookies may be set by us or by third-party advertising partners.
              </p>
            </div>

            {/* Third-Party Cookies */}
            <div className="mb-4">
              <h3 style={{fontSize: '1.2rem', fontWeight: '600', color: '#2c3e50'}}>
                Third-Party Cookies
              </h3>
              <p style={{fontSize: '1rem', color: '#555', marginBottom: '0.5rem'}}>
                We may allow third-party service providers to place cookies on your device through our Site.
              </p>
              <ul style={{fontSize: '1rem', color: '#555', paddingLeft: '1.2rem', marginBottom: '0.5rem', listStyleType: 'disc'}}>
                <li>Analytics Providers (e.g., Google Analytics)</li>
                <li>Payment Processors (for secure transaction processing)</li>
                <li>Social Media Platforms (for social sharing features)</li>
                <li>Advertising Networks (for targeted advertising)</li>
                <li>Customer Support Services (for live chat and support features)</li>
              </ul>
              <p style={{fontSize: '1rem', color: '#555', marginBottom: '0'}}>
                These third parties use cookies in accordance with their own privacy policies.
              </p>
            </div>

            {/* Types of Cookies We Use */}
            <div className="mb-4">
              <h3 style={{fontSize: '1.2rem', fontWeight: '600', color: '#2c3e50'}}>
                Types of Cookies We Use
              </h3>
              <div style={{overflowX: 'auto', marginTop: '1rem'}}>
                <table style={{width: '100%', borderCollapse: 'collapse', fontSize: '1rem', color: '#555'}}>
                  <thead>
                    <tr style={{backgroundColor: '#f8f9fa', borderBottom: '2px solid #dee2e6'}}>
                      <th style={{padding: '0.75rem', textAlign: 'left', fontWeight: '600', color: '#2c3e50'}}>Cookie Type</th>
                      <th style={{padding: '0.75rem', textAlign: 'left', fontWeight: '600', color: '#2c3e50'}}>Purpose</th>
                      <th style={{padding: '0.75rem', textAlign: 'left', fontWeight: '600', color: '#2c3e50'}}>Duration</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style={{borderBottom: '1px solid #dee2e6'}}>
                      <td style={{padding: '0.75rem'}}>Session Cookies</td>
                      <td style={{padding: '0.75rem'}}>Maintain your browsing session</td>
                      <td style={{padding: '0.75rem'}}>Deleted when browser closes</td>
                    </tr>
                    <tr style={{borderBottom: '1px solid #dee2e6'}}>
                      <td style={{padding: '0.75rem'}}>Authentication Cookies</td>
                      <td style={{padding: '0.75rem'}}>Keep you logged in</td>
                      <td style={{padding: '0.75rem'}}>Persistent (varies)</td>
                    </tr>
                    <tr style={{borderBottom: '1px solid #dee2e6'}}>
                      <td style={{padding: '0.75rem'}}>Shopping Cart Cookies</td>
                      <td style={{padding: '0.75rem'}}>Remember items in your cart</td>
                      <td style={{padding: '0.75rem'}}>Persistent (varies)</td>
                    </tr>
                    <tr style={{borderBottom: '1px solid #dee2e6'}}>
                      <td style={{padding: '0.75rem'}}>Analytics Cookies</td>
                      <td style={{padding: '0.75rem'}}>Track site usage and performance</td>
                      <td style={{padding: '0.75rem'}}>Persistent (up to 2 years)</td>
                    </tr>
                    <tr style={{borderBottom: '1px solid #dee2e6'}}>
                      <td style={{padding: '0.75rem'}}>Preference Cookies</td>
                      <td style={{padding: '0.75rem'}}>Remember your settings</td>
                      <td style={{padding: '0.75rem'}}>Persistent (up to 1 year)</td>
                    </tr>
                    <tr>
                      <td style={{padding: '0.75rem'}}>Advertising Cookies</td>
                      <td style={{padding: '0.75rem'}}>Deliver targeted advertisements</td>
                      <td style={{padding: '0.75rem'}}>Persistent (up to 1 year)</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            {/* Your Cookie Choices */}
            <div className="mb-4">
              <h3 style={{fontSize: '1.2rem', fontWeight: '600', color: '#2c3e50'}}>
                Your Cookie Choices
              </h3>
              <p style={{fontSize: '1rem', color: '#555', marginBottom: '0.5rem'}}>
                You have several options for managing cookies:
              </p>

              <p style={{fontSize: '1rem', color: '#555', marginBottom: '0.5rem', fontWeight: '500'}}>
                <strong>Browser Settings</strong>
              </p>
              <p style={{fontSize: '1rem', color: '#555', marginBottom: '0.5rem'}}>
                Most web browsers allow you to control cookies through their settings. You can:
              </p>
              <ul style={{fontSize: '1rem', color: '#555', paddingLeft: '1.2rem', marginBottom: '0.5rem', listStyleType: 'disc'}}>
                <li>View what cookies are stored on your device</li>
                <li>Delete existing cookies</li>
                <li>Block all cookies</li>
                <li>Block third-party cookies</li>
                <li>Block cookies from specific websites</li>
              </ul>
              <p style={{fontSize: '1rem', color: '#555', marginBottom: '1rem'}}>
                Please note that blocking all cookies may prevent you from using certain features of our website, and some services may not function properly.
              </p>

              <p style={{fontSize: '1rem', color: '#555', marginBottom: '0.5rem', fontWeight: '500'}}>
                <strong>How to manage cookies in common browsers:</strong>
              </p>
              <ul style={{fontSize: '1rem', color: '#555', paddingLeft: '1.2rem', marginBottom: '1rem', listStyleType: 'disc'}}>
                <li>Chrome: Settings → Privacy and Security → Cookies and other site data</li>
                <li>Firefox: Settings → Privacy & Security → Cookies and Site Data</li>
                <li>Safari: Preferences → Privacy → Cookies and website data</li>
                <li>Edge: Settings → Cookies and site permissions → Cookies and site data</li>
              </ul>

              <p style={{fontSize: '1rem', color: '#555', marginBottom: '0.5rem', fontWeight: '500'}}>
                <strong>Opt-Out Tools</strong>
              </p>
              <p style={{fontSize: '1rem', color: '#555', marginBottom: '0.5rem'}}>
                You can opt out of certain third-party advertising cookies by visiting:
              </p>
              <ul style={{fontSize: '1rem', color: '#555', paddingLeft: '1.2rem', marginBottom: '1rem', listStyleType: 'disc'}}>
                <li>Digital Advertising Alliance: <a href="http://www.aboutads.info/choices/" target="_blank" rel="noopener noreferrer" style={{color: '#112c3b', textDecoration: 'underline'}}>http://www.aboutads.info/choices/</a></li>
                <li>Network Advertising Initiative: <a href="http://www.networkadvertising.org/choices/" target="_blank" rel="noopener noreferrer" style={{color: '#112c3b', textDecoration: 'underline'}}>http://www.networkadvertising.org/choices/</a></li>
                <li>European Interactive Digital Advertising Alliance: <a href="http://www.youronlinechoices.eu/" target="_blank" rel="noopener noreferrer" style={{color: '#112c3b', textDecoration: 'underline'}}>http://www.youronlinechoices.eu/</a></li>
              </ul>

              <p style={{fontSize: '1rem', color: '#555', marginBottom: '0.5rem', fontWeight: '500'}}>
                <strong>Google Analytics Opt-Out</strong>
              </p>
              <p style={{fontSize: '1rem', color: '#555', marginBottom: '1rem'}}>
                You can opt out of Google Analytics by installing the Google Analytics Opt-out Browser Add-on available at: <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer" style={{color: '#112c3b', textDecoration: 'underline'}}>https://tools.google.com/dlpage/gaoptout</a>
              </p>

              <p style={{fontSize: '1rem', color: '#555', marginBottom: '0.5rem', fontWeight: '500'}}>
                <strong>Do Not Track Signals</strong>
              </p>
              <p style={{fontSize: '1rem', color: '#555', marginBottom: '1rem'}}>
                Some browsers include a "Do Not Track" (DNT) feature that signals to websites you visit that you do not want to have your online activity tracked. Currently, there is no industry standard for how DNT signals should be handled, so we do not currently respond to DNT signals.
              </p>

              <p style={{fontSize: '1rem', color: '#555', marginBottom: '0.5rem', fontWeight: '500'}}>
                <strong>Mobile Devices</strong>
              </p>
              <p style={{fontSize: '1rem', color: '#555', marginBottom: '0.5rem'}}>
                If you access our Site through a mobile device, you may be able to control advertising cookies through your device settings:
              </p>
              <ul style={{fontSize: '1rem', color: '#555', paddingLeft: '1.2rem', marginBottom: '0'}}>
                <li>iOS: Settings → Privacy → Advertising → Limit Ad Tracking</li>
                <li>Android: Settings → Google → Ads → Opt out of Ads Personalization</li>
              </ul>
            </div>

            {/* Changes to This Cookie Policy */}
            <div className="mb-4">
              <h3 style={{fontSize: '1.2rem', fontWeight: '600', color: '#2c3e50'}}>
                Changes to This Cookie Policy
              </h3>
              <p style={{fontSize: '1rem', color: '#555', marginBottom: '0.5rem'}}>
                We may update this Cookie Policy from time to time to reflect changes in technology, legislation, our business operations, or for other reasons. We will post the updated policy on this page with a revised "Last Updated" date.
              </p>
              <p style={{fontSize: '1rem', color: '#555', marginBottom: '0'}}>
                We encourage you to review this Cookie Policy periodically to stay informed about how we use cookies.
              </p>
            </div>

            {/* Contact Us */}
            <div className="mb-4">
              <h3 style={{fontSize: '1.2rem', fontWeight: '600', color: '#2c3e50'}}>
                Contact Us
              </h3>
              <p style={{fontSize: '1rem', color: '#555', marginBottom: '0.5rem'}}>
                If you have any questions about our use of cookies or this Cookie Policy,
              </p>
              <p style={{fontSize: '1rem', color: '#555', marginBottom: '0.5rem', fontWeight: '500'}}>
                Digi Cartt
              </p>
              <p style={{fontSize: '1rem', color: '#555', marginBottom: '0.5rem'}}>
                Email: <a href="mailto:support@digicartt.com" style={{color: '#112c3b', textDecoration: 'underline'}}>support@digicartt.com</a>
              </p>
              <p style={{fontSize: '1rem', color: '#555', marginBottom: '0'}}>
                Website: <a href="https://digicartt.com/" target="_blank" rel="noopener noreferrer" style={{color: '#112c3b', textDecoration: 'underline'}}>https://digicartt.com/</a>
              </p>
            </div>

            {/* Consent */}
            <div className="mb-0">
              <h3 style={{fontSize: '1.2rem', fontWeight: '600', color: '#2c3e50'}}>
                Consent
              </h3>
              <p style={{fontSize: '1rem', color: '#555', marginBottom: '0'}}>
                By continuing to use our website, you consent to our use of cookies as described in this Cookie Policy. If you do not agree to our use of cookies, you should change your browser settings accordingly or refrain from using our Site.
              </p>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cookies;
